import styled from "styled-components";
import { typographyCSS } from "@ifgengineering/design-tokens/legacy";

export const MoneyInputWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.space.sm}px;
  width: 100%;
`;

export const MoneyInputField = styled.input<{ $invalid: boolean }>`
  width: 100%;
  padding: ${({ theme }) => theme.space.md}px;
  border: ${({ theme }) => theme.stroke.md}px solid
    ${({ theme }) => theme.colors.ui.border.subtle};
  background: ${({ theme }) => theme.colors.ui.background.raised};
  text-align: center;
  ${typographyCSS("number.xl")}
  font-size: 44px;
  line-height: 44px;
  color: ${({ theme, $invalid }) =>
    $invalid ? theme.colors.ui.text.error : theme.colors.ui.text.primary};
  border-radius: ${({ theme }) => theme.radius.sm}px;
  transition: color ${({ theme }) => theme.motion.duration.quick}ms
      ${({ theme }) => theme.motion.easing.standard},
    border-color ${({ theme }) => theme.motion.duration.quick}ms
      ${({ theme }) => theme.motion.easing.standard};

  &::placeholder {
    color: ${({ theme }) => theme.colors.ui.text.disabled};
  }

  /* A ring around the field read as a validation state, so focus darkens the stroke. */
  &:focus-visible {
    outline: none;
    border-color: ${({ theme }) => theme.colors.ui.border.strong};
  }

  &:disabled {
    color: ${({ theme }) => theme.colors.ui.text.disabled};
  }
`;

export const MoneyInputCaption = styled.p`
  margin: ${({ theme }) => theme.space.sm}px 0 0;
  text-align: center;
  ${typographyCSS("body.sm")}
  color: ${({ theme }) => theme.colors.ui.text.tertiary};
`;

export const MoneyInputError = styled.p`
  margin: 0;
  text-align: center;
  ${typographyCSS("body.sm")}
  color: ${({ theme }) => theme.colors.ui.text.error};
`;
